import GetTerminalRequestComponent from '../Pages/TID Handling/GetTerminalIdRequest';

const AccessV2TIDHandlingComponent = () => {
    return (
        <article className="docs-article" id="section-5">

            <header className="docs-header">
                <h1 className="docs-heading">TID(Terminal Id) Handling <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>A TID (Terminal ID) handling service facilitates the allocation of unique terminal identifiers for merchant stores and specific ECR devices. Merchants initiate the process by onboarding their stores as sub-customers under a parent customer account in the Westpay Access portal. Subsequently, merchants can request a certain number of terminals for the sub-customer account through the portal. The merchant then utilizes the POST /getTerminalIds service within their ECR application to obtain a terminal ID. This terminal ID is assigned to the provided ECR ID after submitting the corresponding store ID and ECR ID, enabling effective TID management and allocation.</p>
                    <br />
                    <div className="docs-intro-section">
                        <h3>ECR on-boarding process flow.</h3>
                        <br />
                        <img className="responsive" src="/assets/images/contents/AccessGetTerminalId.png" alt="Terminal onboarding overview" style={{ marginBottom: "20px" }}></img>
                        <br />
                    </div>
                </section>
            </header>

            <GetTerminalRequestComponent/>
        </article>
    )
}

export default AccessV2TIDHandlingComponent;